<template>
  <div class="rtportal">
    <router-view></router-view>
  </div>
</template>

<script>
import heartbeat from "@/plugins/heartbeat";
import auth from "@/auth";
export default {
  mounted: function () {
    if (!heartbeat.isAlive()) {
      auth.logout();
    }

    heartbeat.keepAlive();
  },
};
</script>
<style>
/* 滚动条宽度 */
body::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
/*滚动条的滑块*/
body::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 3px;
} 
</style>



// WEBPACK FOOTER //
// App.vue?8ecb926c